import { useState } from 'react';
import { FaImage } from 'react-icons/fa';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  style: React.CSSProperties;
  className?: string;
  errImgSize?: string;
}

export const ImageWithFallback = ({
  src,
  alt,
  style,
  className,
  errImgSize = '2rem',
}: ImageWithFallbackProps) => {
  const [error, setError] = useState(false);

  return error ? (
    <FaImage
      style={{ fontSize: errImgSize }}
      color="gray"
      className={className}
    />
  ) : (
    <img
      className={className}
      src={src}
      alt={alt}
      style={style}
      onError={() => setError(true)}
    />
  );
};
